export enum AlbumFileType {
  IMAGE = 'img',
  VIDEO = 'vid',
}
